// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"46":"4d3c8da8","462":"88a878bc"}[chunkId] + ".chunk.css";
};